import { graphql } from "@/graphql/codegen/gql"

graphql(`
  mutation AddSpecialPrice($input: AddSpecialPricePackageInput!) {
    priceChange {
      addSpecialPricePackage(input: $input) {
        ... on AddSpecialPricePackageSuccess {
          specialPricePackage {
            id
            productId
            companyId
            shipFromId
            incoterms
            incotermsLocationId
          }
        }
        ... on AddSpecialPricePackageFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation AddPurchasingCostPackage($input: AddPurchasingCostPackageInput!) {
    priceChange {
      addPurchasingCostPackage(input: $input) {
        ... on AddPurchasingCostPackageSuccess {
          productPurchasingCostPackage {
            id
            productId
            shipToId
            incoterms
            incotermsLocationId
            freightTerm
          }
        }
        ... on AddPurchasingCostPackageFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation SubmitPriceChanges($input: SubmitPriceChangesInput!) {
    priceChange {
      submitPriceChanges(input: $input) {
        ... on SubmitPriceChangesSuccess {
          priceChangeSubmission {
            id
            changeId
            status
            changeType
          }
        }
        ... on SubmitPriceChangesFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation ApprovePriceChange($input: ApprovePriceChangeInput!) {
    priceChange {
      approvePriceChange(input: $input) {
        ... on ApprovePriceChangeSuccess {
          priceChangeSubmission {
            id
            changeId
            status
          }
        }
        ... on ApprovePriceChangeFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation DenyPriceChange($input: DenyPriceChangeInput!) {
    priceChange {
      denyPriceChange(input: $input) {
        ... on DenyPriceChangeSuccess {
          priceChangeSubmission {
            id
            changeId
            status
          }
        }
        ... on DenyPriceChangeFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation UpdatePriceChangeSubmission($input: UpdatePriceChangeSubmissionInput!) {
    priceChange {
      updatePriceChangeSubmission(input: $input) {
        ... on UpdatePriceChangeSubmissionSuccess {
          priceChangeSubmission {
            id
            changeId
            status
          }
        }
        ... on UpdatePriceChangeSubmissionFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation RevertPriceChangeSubmission($input: RevertPriceChangeSubmissionInput!) {
    priceChange {
      revertPriceChangeSubmission(input: $input) {
        ... on RevertPriceChangeSubmissionSuccess {
          priceChangeSubmission {
            id
            changeId
            status
          }
        }
        ... on RevertPriceChangeSubmissionFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation DeleteSubmission($input: DeleteSubmissionInput!) {
    priceChange {
      deleteSubmission(input: $input) {
        ... on DeleteSubmissionSuccess {
          success
        }
        ... on DeleteSubmissionFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation DeleteSubmissionProduct($input: DeleteSubmissionProductInput!) {
    priceChange {
      deleteSubmissionProduct(input: $input) {
        ... on DeleteSubmissionProductSuccess {
          success
        }
        ... on DeleteSubmissionProductFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation PromoteDraftSubmission($input: PromoteDraftInput!) {
    priceChange {
      promoteDraft(input: $input) {
        ... on PromoteDraftSuccess {
          priceChangeSubmission {
            id
            changeId
            status
          }
        }
        ... on PromoteDraftFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation ResendToAllCustomers($input: ResendToAllCustomersInput!) {
    priceChange {
      resendToAllCustomers(input: $input) {
        ... on ResendToAllCustomersSuccess {
          success
        }
        ... on ResendToAllCustomersFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation ResendToIndividualCustomer($input: ResendToIndividualCustomerInput!) {
    priceChange {
      resendToIndividualCustomer(input: $input) {
        ... on ResendToIndividualCustomerSuccess {
          success
        }
        ... on ResendToIndividualCustomerFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation ResendToIndividualPerson($input: ResendToIndividualPersonInput!) {
    priceChange {
      resendToIndividualPerson(input: $input) {
        ... on ResendToIndividualPersonSuccess {
          success
        }
        ... on ResendToIndividualPersonFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
